/**
 * Socket 관련 타입 정의
 */

export enum ConnectionState {
  INIT = "init",
  DISCONNECTED = "disconnected",
  CONNECTING = "connecting",
  CONNECTED = "connected",
  RECONNECTING = "reconnecting",
}

export type EventCallback = (...args: any[]) => void;

export type RoomId = string;
